import setupMedia from "./modules/media";
import setupInfo from "./modules/info";
import Product from "./modules/product";
import accordions from "./modules/accordions";

export const productTempalte = () => {
  const $productTemplates = document.querySelectorAll(".product-template");

  $productTemplates.forEach(($productTemplate) => {
    const product = new Product($productTemplate);
    setupMedia($productTemplate);
    setupInfo($productTemplate, product);
    accordions($productTemplate);
  });
};

export default productTempalte;
